import cloneDeep from 'lodash/cloneDeep'
import {
  SET_INITIAL_FILTER_INFO,
  UPDATE_ATTRIBUTES_FILTERS_UI,
} from '../../../actions/actionTypes'

export const attributesState = [
  {
    value: 'CARRY_ON',
    primaryLabel: 'Carry-on bag',
    secondaryLabel: '',
    checked: false,
    disabled: false,
  },
  {
    value: 'SEATS',
    primaryLabel: 'Seat selection',
    secondaryLabel: '',
    checked: false,
    disabled: false,
  },
  // {
  //   value: 'CHECKED_BAG',
  //   primaryLabel: 'Checked bag',
  //   secondaryLabel: '',
  //   checked: false,
  //   disabled: false,
  // },
  // {
  //   value: 'NO_CHANGE_FEES',
  //   primaryLabel: 'No change fees',
  //   secondaryLabel: '',
  //   checked: false,
  //   disabled: false,
  // },
]

/* Attributes */
export const attributesFilter = (state = [], action) => {
  const { type, payload = {}, meta = {} } = action
  switch (type) {
    case SET_INITIAL_FILTER_INFO:
      return cloneDeep(attributesState)

    case UPDATE_ATTRIBUTES_FILTERS_UI:
      return state.map(attributeObj => {
        if (meta.isNoneClick) {
          attributeObj.checked = false
        } else if (meta.isAllClick) {
          attributeObj.checked = true
        } else if (meta.isOnlyClick) {
          attributeObj.checked = attributeObj.value === payload.value
        } else {
          attributeObj.checked =
            attributeObj.value === payload.value
              ? payload.checked
              : attributeObj.checked
        }
        return { ...attributeObj }
      })

    default:
      return state
  }
}
